import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Category from '@mui/icons-material/Category';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import Progress from '../components/Loader';
import { getproduct} from '../redux/product';
import { CROP_PRODUCT_OPTIONS_WITH_RICE } from '../constants/cropProducts';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 550,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function BasicModal() {
  const [open, setOpen] = React.useState(false);
  const [category, setcategory] = React.useState("none");
  const [loading, setloading] = React.useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();

  const Food = CROP_PRODUCT_OPTIONS_WITH_RICE;

  const clearForm = () => {
    setcategory("none");
    document.getElementById("productname").value = "";
    document.getElementById("bestplant").value = "";
    document.getElementById("bestharvest").value = "";
    document.getElementById("nutrition").value = "";
    document.getElementById("description").value = "";
    document.getElementById("condition").value = "";
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  const addproduct = () => {
    setloading(true);
    const doer = async () => {
      try {
        const res = await axios.post("https://server.agrotraciserp.com/api/product/addproduct/", {
          productname: document.getElementById("productname").value,
          category: category,
          bestplant: document.getElementById("bestplant").value,
          bestharvest: document.getElementById("bestharvest").value,
          nutrition: document.getElementById("nutrition").value,
          description: document.getElementById("description").value,
          condition: document.getElementById("condition").value,
        });
        if (res.status === 200) {
          setloading(false);
          dispatch(getproduct( { data: res.data } ));
          setSnackbarMessage('Product added successfully!');
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          clearForm();
          handleClose();
        } else {
          setloading(false);
          setSnackbarMessage('Failed to add product.');
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      } catch (err) {
        setloading(false);
        setSnackbarMessage('An error occurred while adding product.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    };
    doer();
  };

  return (
    <div>
      <Button variant="outlined" startIcon={<Category />} onClick={handleOpen}>
        Add Product
      </Button>
      <Dialog fullWidth minWidth="sm" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Add new Product
          <IconButton onClick={handleClose} style={{ float: "right" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="productname"
              label="Product Name"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="outlined-select-currency-native"
              select
              label="Category"
              value={category}
              onChange={(e) => setcategory(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="none">Select Category</option>
              {Food.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </TextField>
            <TextField
              id="bestplant"
              label="Best Season for planting"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="bestharvest"
              label="Best Season for harvest"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="nutrition"
              label="Nutritional Info"
              multiline
              rows={4}
            />
            <TextField
              id="description"
              label="Product Description"
              multiline
              rows={4}
            />
            <TextField
              id="condition"
              label="Optimum Storage Condition"
              multiline
              rows={4}
            />
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <div style={{ marginTop: 2, textAlign: "center", width: "100%" }}>
            {loading ? (
              <Button variant="outlined" startIcon={<Progress />} disabled>
                Loading...
              </Button>
            ) : (
              <Button variant="outlined" startIcon={<Category />} size="large" onClick={addproduct}>
                Submit New Product
              </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}